<template>
    <div :class="['partner-card', col]">
        <div class="partner-card__inner">
            <div class="partner-card__cover">
                <img :src="image" :alt="title">
            </div>
            <div class="partner-card__title">{{ title }}</div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PartnerCard',
    inheritAttrs: false,
    props: {
        image: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        col: {
            type: String,
            default: '',
        }
    },
    setup: (props, ctx) => {
        
        return {

        }
    },
}
</script>

<style lang="scss">
    .partner-card {
        &__cover {
            position: relative;
            padding: 0 0 60% 0;
            border: 1px solid var(--c-gray-700);
            border-radius: var(--br-1);
            background: #fff;
            overflow: hidden;

            img {
                object-fit: contain;
                object-position: center center;
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                margin: auto;
                padding: 16px;
            }
        }
        &__title {
            margin-top: 14px;
            font-size: 18px;
            font-family: var(--font-secondary);
            font-weight: 600;
            color: var(--c-gray-120);
            text-align: center;

            @include tablet {
                margin-top: 10px;
                font-size: 14px;
                line-height: 19px;
            }
            @include mobile {
                margin-top: 6px;
                font-size: 12px;
                line-height: 16px;
            }
        }
    }
</style>
